import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { Modal, Form, Input, Button, CheckboxGroup, Checkbox } from 'rsuite';
import HeaderOfPage from '../tools/headerOfPage';

export default function PriceEditor({ Id }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();

    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [listpost, setListPost] = useState<any[]>([]);
    const [listprices, setListpirces] = useState<any[]>([]);
    const [listSubGroup, setListSubGroup] = useState<any[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [showModalGroup, setShowModalGroup] = useState(false);
    const [formData, setFormData] = useState({ subgroup: null, id: null, parent: Id, name: '', unit: 'unit', description: '', price: 0, amount: 0, post: [] });
    const [formDataGroup, setFormDataGroup] = useState({ id: null, code: '', parent: Id, name: '' });
    const handleFormChange = (field: string, value: any) => {
        setFormData({ ...formData, [field]: value });
    };
    const handleFormChangeGroup = (field: string, value: any) => {
        setFormDataGroup({ ...formDataGroup, [field]: value });
    };

    const handleSave = async () => {
        if (formData.id != null) {
            try {
                var path = `${config.url}/v1/dashboard/price/${formData.id}`;

                let res = await axios({
                    method: 'put',
                    data: formData,
                    url: path,
                    headers: {
                        Authorization: 'Bearer ' + cookie['token'],
                    }
                });
                loaditem(Id);
                setShowModal(false);
            } catch (error) {

            }
        } else {
            try {
                var path = `${config.url}/v1/dashboard/price`;

                let res = await axios({
                    method: 'post',
                    data: formData,
                    url: path,
                    headers: {
                        Authorization: 'Bearer ' + cookie['token'],
                    }
                });
                loaditem(Id);
                setShowModal(false);
                loadSubGroup();

            } catch (error) {

            }
        }

    };
    const loaditem = async (id: any) => {
        try {
            var path = `${config.url}/v1/dashboard/price/list/${id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setListpirces(res.data.message);
        } catch (error) {

        }
    }

    const [data, setData] = React.useState<any>(null);
    const save = async () => {
        try {
            var path = `${config.url}/v1/dashboard/productprice/${Id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire('Update Data')
        } catch (error) {

        }
    }
    const deleted = async (id: any) => {
        try {
            var path = `${config.url}/v1/dashboard/price/${id}`;

            let res = await axios({
                method: 'delete',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            load();
            loaditem(Id);
            loadSubGroup();
        } catch (error) {

        }
    }

    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/productprice/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData(res.data.message)
        } catch (error) {

        }
        try {
            var path = `${config.url}/v1/dashboard/postmethods`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            console.log(res.data.message);
            setListPost(res.data.message)
        } catch (error) {

        }
        ////v1/dashboard/postmethods
    }
    const loadSubGroup = async () => {
        axios.get(`${config.url}/v1/dashboard/subgprice?parent=${Id}`, {
            headers: {
                Authorization: 'Bearer ' + cookie['token'],
            }
        }).then((res) => {
            setListSubGroup(res.data.message);
        }).catch((err) => {
            console.log(err);
        })
    }
    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/ProductsGroup'
        },
        {
            name: 'PriceGroup Group List',
            url: '/dashboard/PriceGroup'
        },
        {
            name: 'Edit PriceGroup Group List',
            url: null
        }
    ]
    useEffect(() => {
        load();
        loaditem(Id);
        loadSubGroup();

    }, []);
    function formatPrice(price: number, defaultCurrency: string = 'IRR'): string {
        try {
            if (typeof price !== 'number') throw new Error('Price must be a number');

            const userLocale: string = navigator.language || 'fa-IR';

            // Explicitly define the type of currencyMap
            const currencyMap: Record<string, string> = {
                'en-US': 'USD',
                'en-GB': 'GBP',
                'de-DE': 'EUR',
                'fr-FR': 'EUR',
                'ja-JP': 'JPY',
                'fa-IR': 'IRR',
                'ar-SA': 'SAR',
            };

            // Ensure the currency exists, otherwise use default
            const currency: string = currencyMap[userLocale] ?? defaultCurrency;

            return new Intl.NumberFormat(userLocale, {
                style: 'currency',
                currency: currency,
            }).format(price);
        } catch (error) {
            console.error('formatPrice Error:', error);
            return `${price} `; // Fallback to basic format
        }
    }
    const EditPrice = (id: any) => {
        setFormData(id);
        setShowModal(true);
    }
    const handleSaveGroup = async () => {
        if (formDataGroup.id == null) {
            try {
                var path = `${config.url}/v1/dashboard/subgprice`;

                let res = await axios({
                    method: 'post',
                    data: formDataGroup,
                    url: path,
                    headers: {
                        Authorization: 'Bearer ' + cookie['token'],
                    }
                });
                setShowModalGroup(false);
                loaditem(Id);
                loadSubGroup();
            } catch (error) {

            }
        } else {
            try {
                var path = `${config.url}/v1/dashboard/subgprice/${formDataGroup.id}`;

                let res = await axios({
                    method: 'put',
                    data: formDataGroup,
                    url: path,
                    headers: {
                        Authorization: 'Bearer ' + cookie['token'],
                    }
                });
                setShowModalGroup(false);
                loaditem(Id);
                loadSubGroup();
            } catch (error) {

            }

        }
    }
    const EditGroupPrice = (item: any) => {
        setFormDataGroup({ id: item._id, parent: Id, name: item.name, code: item.code || '' });
        setShowModalGroup(true);
    }
    const deletedGroup = async (id: any) => {
        try {
            var path = `${config.url}/v1/dashboard/subgprice/${id}`;

            let res = await axios({
                method: 'delete',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loadSubGroup();
        } catch (error) {

        }
    }
    return (
        <div>
            {
                data != null && <div className='grid grid-cols-1 sm:grid-cols-5'>

                    <div className='col-span-1 sm:col-span-5 p-4'>

                        <div className='w-full flex gap-2 items-start'>
                            <Button
                                className={`right w-[100px]`}
                                style={{ backgroundColor: 'red', color: '#fff' }}
                                color={`red`}
                                onClick={(e) => {
                                    setFormData({ subgroup: null, id: null, parent: Id, name: '', unit: 'unit', description: '', price: 0, amount: 0, post: [] });
                                    setShowModal(true);
                                }}
                            >اضافه کردن</Button>

                            <Button
                                className={`right w-[200px]`}
                                style={{ backgroundColor: 'red', color: '#fff' }}
                                color={`red`}
                                onClick={(e) => {
                                    setFormDataGroup({ id: null, parent: Id, name: '', code: '' });
                                    setShowModalGroup(true);
                                }}
                            >
                                اضافه گروه قیمت جدید
                            </Button>


                        </div>
                        <div>

                            {
                                listprices.map((item: any) => {
                                    return (
                                        <div className='p-4' >
                                            <div className={`grid grid-cols-4 items-center bg-slate-100 p-4`}>
                                                <div>

                                                    <div className=' text-right'>{item.name} </div>
                                                    <p className='text-right'>{item.description}</p>

                                                </div>
                                                <div>
                                                    {item.price}
                                                </div>
                                                <div>

                                                </div>
                                                <div>
                                                    <Button
                                                        onClick={(e) => {
                                                            EditPrice(item);
                                                        }}

                                                    >{t('Edit')}</Button>
                                                    <button
                                                        onClick={(e) => { deleted(item.id) }}
                                                        type="button"
                                                        className=" "
                                                    >{t('Delete')} </button>
                                                </div>

                                            </div>

                                        </div>
                                    )
                                })
                            }
                            {
                                listSubGroup.map((item: any) => {
                                    return (
                                        <div className='p-4' >
                                            <div className={`flex flex-row gap-2 justify-between items-center bg-red-300 p-4`}>
                                                <div>

                                                    <div className=' text-right'>گروه :{item.name} </div>

                                                </div>

                                                <div className='flex gap-2 '>
                                                    <Button
                                                        className={`right w-[100px]`}
                                                        style={{ backgroundColor: 'red', color: '#fff' }}
                                                        color={`red`}
                                                        onClick={(e) => {
                                                            setFormData({ subgroup: item._id, id: null, parent: Id, name: '', unit: 'unit', description: '', price: 0, amount: 0, post: [] });
                                                            setShowModal(true);
                                                        }}
                                                    >اضافه کردن</Button>
                                                    <Button
                                                        onClick={(e) => {
                                                            EditGroupPrice(item);
                                                        }}

                                                    >ویرایش نام گروه</Button>
                                                    <button
                                                        onClick={(e) => { deletedGroup(item.id) }}
                                                        type="button"
                                                        className=" "
                                                    >{t('Delete')} </button>
                                                </div>

                                            </div>
                                            {
                                                item.toprice.map((item: any) => {
                                                    return (
                                                        <div className='p-4' >
                                                            <div className={`grid grid-cols-4 items-center bg-slate-100 p-4`}>
                                                                <div>

                                                                    <div className=' text-right'>{item.name} </div>
                                                                    <p className='text-right'>{item.description}</p>

                                                                </div>
                                                                <div>
                                                                    {item.price}
                                                                </div>
                                                                <div>

                                                                </div>
                                                                <div>
                                                                    <Button
                                                                        onClick={(e) => {
                                                                            EditPrice(item);
                                                                        }}

                                                                    >{t('Edit')}</Button>
                                                                    <button
                                                                        onClick={(e) => { deleted(item.id) }}
                                                                        type="button"
                                                                        className=" "
                                                                    >{t('Delete')} </button>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>
                                    )
                                })
                            }

                        </div>

                    </div>
                </div>
            }
            <Modal open={showModalGroup} onClose={() => setShowModalGroup(false)}>
                <Modal.Header>
                    <Modal.Title> گروه </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form fluid>
                        <div className="flex flex-col gap-3 p-4">
                            <label>نام گروه قیمت</label>
                            <Input name="name" value={formDataGroup.name}
                                onChange={(value: any) => handleFormChangeGroup('name', value)}
                            />
                            <label>کد محصول</label>

                            <Input name="name" value={formDataGroup.code}
                                onChange={(value: any) => handleFormChangeGroup('code', value)}
                            />

                        </div>
                        <Modal.Footer>
                            <Button onClick={handleSaveGroup} appearance="primary">ذخیره</Button>
                            <Button onClick={() => setShowModalGroup(false)} appearance="subtle">لغو</Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal open={showModal} onClose={() => setShowModal(false)}>
                <Modal.Header>
                    <Modal.Title>ایجاد فرم جدید</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form fluid>
                        <div className="flex flex-col gap-3 p-4">
                            <label>نام</label>
                            <Input name="name" value={formData.name} onChange={(value: any) => handleFormChange('name', value)} />

                            <label>مقدار</label>
                            <Input dir="ltr" name="amount" value={formData.amount} onChange={(value: any) => handleFormChange('amount', value)} />
                            <label>واحد</label>
                            <select name="unit" value={formData.unit} onChange={(e) => handleFormChange('unit', e.target.value)}>
                                <option value="kg">کیلوگرم</option>
                                <option value="liter">لیتر</option>
                                <option value="gram">گرم</option>
                                <option value="mile">میل</option>
                                <option value="number">عدد</option>
                                <option value="pack">پک</option>
                                <option value="package">بسته</option>

                                <option value="">دیگر</option>
                            </select>

                            <label>توضیحات</label>
                            <Input name="description" value={formData.description} onChange={(value: any) => handleFormChange('description', value)} />

                            <label>قیمت</label>
                            <Input dir="ltr" type='number' name="price" value={formData.price} onChange={(value: any) => handleFormChange('price', value)} />

                            <CheckboxGroup name="checkbox-group" value={formData.post} onChange={(value) => handleFormChange('post', value)}>
                                {
                                    listpost != null && listpost.map((item: any) => {
                                        return (
                                            <Checkbox key={item._id} value={item._id}>{item.name} ({item.text})</Checkbox>
                                        )
                                    })
                                }
                            </CheckboxGroup>

                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleSave} appearance="primary">ذخیره</Button>
                    <Button onClick={() => setShowModal(false)} appearance="subtle">لغو</Button>
                </Modal.Footer>
            </Modal>
            <div>

            </div>
        </div>
    )
}